import AlgoliaIndex from '~/algolia/algolia-index';
import { TrainingIndexFormatters } from '~/algolia/training/training-index-formatters';
import SearchApi from '../../agent/search';

const TrainingIndices = {
  TRAINING: new AlgoliaIndex(
    APP_CONSTANTS.ALGOLIA_INDEXES.TRAINING,
    {
      attributesToSnippet: ['name', 'title', 'description', 'content', 'object_tags'],
    },
    TrainingIndexFormatters.formatTrainingResult,
    (results) => SearchApi.filterSearchableObjectIdsAndCombine(results),
  ),

  getAll() {
    return [this.TRAINING];
  },
};

export default TrainingIndices;
